export const resolveWsUrl = () => {
  const fallbackApiUrl = import.meta.env.VITE_API_URL
    ? import.meta.env.VITE_API_URL.replace(/^http/, 'ws')
    : undefined;
  const rawUrl = import.meta.env.VITE_WS_URL || fallbackApiUrl;

  if (!rawUrl) {
    throw new Error('Missing websocket URL: set VITE_WS_URL or VITE_API_URL');
  }

  try {
    return new URL(rawUrl);
  } catch {
    throw new Error(`Invalid websocket URL: ${rawUrl}`);
  }
};
